import React from 'react';
import './Blog.css'; 
import {Link} from "react-router-dom";

const Blog = () => {
  return (
    <section className="blog-wrapper-main">
      <div className="blog-container">
        <div className="blog-content">
          <p className="blog-badge">Blog</p>
          <h1 className="blog-title">Latest Posts</h1>
          <p className="blog-subtitle">
            Stay ahead of the curve, explore new ideas, and engage with the pulse of evolving trends through our repository of timely and insightful content.
          </p>
        </div>
        <Link to='/BlogDetails' className="blog-link">
          <button className="blog-view-more-btn">View More</button> 
        </Link>
      </div>
    </section>
  );
};

export default Blog;
